
define(function (require) {
    "use strict";

    var LE = require("app");
    var FacebookSubscribedPageModel = require("manager-models/data-sources/conversation-sources/FacebookSubscribedPageModel");

    var FacebookSubscribedPagesCollection = {};

    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        FacebookSubscribedPagesCollection = Backbone.Collection.extend({
            model : FacebookSubscribedPageModel
        });
    });

    return FacebookSubscribedPagesCollection;
});
